import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export function useLoginRedirect() {
  const { isLoading, isAuthenticated, error, loginWithRedirect } = useAuth0();
  const redirectStarted = useRef(false);

  useEffect(() => {
    if (redirectStarted.current) {
      return;
    }

    if (!isLoading && !isAuthenticated && !error) {
      redirectStarted.current = true;
      loginWithRedirect({
        authorizationParams: {
          prompt: 'login',
        },
      });
    }
  }, [isLoading, isAuthenticated, error, loginWithRedirect]);

  return { isLoading, isAuthenticated, error };
}
